import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-593d79ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-full tw-flex md:tw-flex-col tw-gap-4 tw-box-borders" }
const _hoisted_2 = { class: "tw-w-[440px] tw-h-auto tw-flex tw-flex-col tw-gap-4 tw-px-0 rmd:tw-px-2 tw-box-border tw-overflow-y-auto md:tw-w-full tw-max-w-full" }
const _hoisted_3 = {
  key: 2,
  class: "service-plan-card"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Does Your Property have a heat pump?", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Get your annual service, from £30 per month.", -1))
const _hoisted_6 = { class: "service-plan-card__footer" }

import { LatLngExpression } from "leaflet";
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import PropertyHeatServicePlanModal from "@/modules/properties/components/Modals/PropertyHeatServicePlanModal.vue";
import PropertyCard from "@/modules/properties/components/Cards/PropertyCard.vue";
import CollapsiblePropertySummary from "../Collapsibles/CollapsiblePropertySummary.vue";
import CollapsiblePropertyProjects from "../Collapsibles/CollapsiblePropertyProjects.vue";
import CollapsiblePropertyRecommendation from "../Collapsibles/CollapsiblePropertyRecommendation.vue";
import CollapsiblePropertySafetyChecks from "../Collapsibles/CollapsiblePropertySafetyChecks.vue";
import CollapsiblePropertyConnection from "../Collapsibles/CollapsiblePropertyConnection.vue";
import CollapsiblePropertyOccupiers from "../Collapsibles/CollapsiblePropertyOccupiers.vue";
import { PROPERTY_STORE } from "@/store/modules/property";
import PropertyGoogleMap from "@/core/components/map/PropertyGoogleMap.vue";
import { parseJSON } from "@/core/utils/common";
import GoogleMap2 from "@/core/components/map/GoogleMap2.vue";
import { PropertySubscriptionTypeEnum } from "@/core/enums/ProjectsEnum";
import CollapsiblePropertyProjectNotifications from "../Collapsibles/CollapsiblePropertyProjectNotifications.vue";
import ProjectLogSidenav from "@/modules/properties/components/ProjectLogSidenav.vue";

// import CollapsiblePropertyProjectsDepracated from "../Collapsibles/CollapsiblePropertyProjects_depracated.vue";
import CollapsiblePropertyRecommendationDepracated from "../Collapsibles/CollapsiblePropertyRecommendation_depracated.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyMapTab',
  emits: ["route-to-project-logs"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const isOpenProjectLogSidenav = ref(false);
const isMobileMapOpen = ref(false);

const propertyDetails = computed(
  () => store.getters[`${PROPERTY_STORE}/propertyDetails`]
);
const isSiteVisitPropertyDetail = computed(
  () => store.getters[`${PROPERTY_STORE}/getIsSiteVisitPropertyDetail`]
);
const addressData = computed(() => {
  const propertyAddress = propertyDetails.value?.localData;
  return parseJSON(propertyAddress?.addressData);
});
const isShowServicePlanModal = ref(false);
const onToggleAServicePlanModal = () => {
  isShowServicePlanModal.value = !isShowServicePlanModal.value;
};

const isUserHapHeatPumpServicePlan = computed(
  () =>
    propertyDetails.value?.localData?.propertySubscriptions?.some(
      (plan: any) =>
        plan.type === PropertySubscriptionTypeEnum.HEAT_PUMP_SERVICE
    ) || null
);

const onFullScreenRequest = () => {
  isMobileMapOpen.value = true;
};

const onCloseMobileFullScreenMap = () => {
  isMobileMapOpen.value = false;
};

const openSideNav = () => {
  isOpenProjectLogSidenav.value = true;
};

const redirectToProjectLogs = () => {
  emits("route-to-project-logs");
};
const closeSideNav = () => {
  isOpenProjectLogSidenav.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PropertyCard, {
          onOnMapFullScreen: onFullScreenRequest,
          hasOpenMapButtonInMobile: true
        }),
        (!isSiteVisitPropertyDetail.value)
          ? (_openBlock(), _createBlock(CollapsiblePropertyProjects, {
              key: 0,
              onRouteToProjectLogs: redirectToProjectLogs
            }))
          : _createCommentVNode("", true),
        _createVNode(CollapsiblePropertyRecommendation),
        _createVNode(CollapsiblePropertyProjectNotifications, { onOnOpenLogs: openSideNav }),
        (!isSiteVisitPropertyDetail.value)
          ? (_openBlock(), _createBlock(CollapsiblePropertySafetyChecks, { key: 1 }))
          : _createCommentVNode("", true),
        (!isUserHapHeatPumpServicePlan.value && !isSiteVisitPropertyDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_btn, {
                  class: "bright-blue-text",
                  variant: "text",
                  "append-icon": "mdi-chevron-right",
                  onClick: onToggleAServicePlanModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Get Your Service Plan ")
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["tw-h-[670px] rlg:!tw-h-[calc(100vh-17rem)] tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-overflow-hidden tw-relative tw-w-[calc(100%-460px)] lg:tw-w-full", { 'md:!tw-hidden': !isMobileMapOpen.value }])
      }, [
        (addressData.value)
          ? (_openBlock(), _createBlock(PropertyGoogleMap, {
              key: 0,
              onCloseFullScreenMobileMap: onCloseMobileFullScreenMap,
              addressData: addressData.value,
              propertyId: propertyDetails.value?.localData?.id,
              isMobileMapOpen: isMobileMapOpen.value,
              ref: "googleMap"
            }, null, 8, ["addressData", "propertyId", "isMobileMapOpen"]))
          : _createCommentVNode("", true),
        (isShowServicePlanModal.value)
          ? (_openBlock(), _createBlock(PropertyHeatServicePlanModal, {
              key: 1,
              onOnClose: onToggleAServicePlanModal
            }))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(ProjectLogSidenav, {
      isOpen: isOpenProjectLogSidenav.value,
      onOnClose: closeSideNav
    }, null, 8, ["isOpen"])
  ], 64))
}
}

})